export default {
  computed: {
    /**
     * please override this method
     * Example:
     * return this.$c('_profileConfiguration').personalDataSection;
     */
    sectionConfig() {
      return undefined;
    },
  },
  methods: {
    customRegexpValidation(value){
      if(value){
        if(value.match(/^[^%\\$!§`´<>=?^()|:]*$/)){
          return true;
        }else{
          return false;
        }
      }else{
        return true;
      }
    },
    customEmailRegexpValidation(value){
      if(value){
        if(value.match(/^[^*]*$/)){
          return true;
        }else{
          return false;
        }
      }else{
        return true;
      }
    },
    passkeyNameRegexValidation(value){
      if(!value) return false;
      return /^[a-zA-Z0-9-\s]{1,50}$/.test(value);
    },
    isMaxLengthValid(key, value) {
      const maxLength = this.getMaxLength(key);
      if (!maxLength) return true;
      return value && value.length ? value.length <= maxLength : true;
    },
    isMinLengthValid(key, value) {
      const minLength = this.getMinLength(key);
      if (!minLength) return true;
      const isRequired = this.isRequired(key);
      const length = value && value.length ? value.length : 0;
      if (isRequired) return length >= minLength;
      return length === 0 || length >= minLength;
    },
    isRegExValid(key, value, isRegExpCaseInsensitive = false) {
      const regEx = this.getRegEx(key);
      if (!regEx) return true;
      const isRequired = this.isRequired(key);
      if (!isRequired && !value) return true;

      if(isRegExpCaseInsensitive) {
        // The flag "i" allows for a case-insensitive check
        let regExObj = new RegExp(regEx, "i");

        return regExObj.test(value);
      }
      else {
        if(value.match(regEx)) {
          return true;
        }
        else {
          return false;
        }
      }
    },
    isPostalCodeRegExValid(key, value, country) {
      const regEx = this.getPostalCodeRegEx(key, country);
      if (!regEx) return true;
      const isRequired = this.isRequired(key);
      if (!isRequired && !value) return true;

      // The flag "i" allows for a case-insensitive check
      let regExObj = new RegExp(regEx, "i");

      return regExObj.test(value);
    },
    getMinLength(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].minLength : undefined;
    },
    getMaxLength(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].maxLength : 50
    },
    getRegEx(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] && sectionConfig[key].regEx ? sectionConfig[key].regEx : "";
    },
    getPostalCodeRegEx(key, country) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] && sectionConfig[key].countryValidation?.[country] ? sectionConfig[key].countryValidation[country] : "";
    },
    getOrder(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] && sectionConfig[key].order ? sectionConfig[key].order : 100;
    },
    getFormOrder(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] && sectionConfig[key].order ? sectionConfig[key].formOrder : 100;
    },
    getCountrySpecificOrder(key, configSubSection, countryKey) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = (this.sectionConfig && this.sectionConfig[configSubSection]) ? this.sectionConfig[configSubSection][countryKey] : undefined;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] && sectionConfig[key].order ? sectionConfig[key].order : 100;
    },
    getCountrySpecificFormOrder(key, configSubSection, countryKey) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = (this.sectionConfig && this.sectionConfig[configSubSection]) ? this.sectionConfig[configSubSection][countryKey] : undefined;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] && sectionConfig[key].formOrder ? sectionConfig[key].formOrder : 100;
    },
    // getTolerantSinglelineOrder(key) {
    //   // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //   // @ts-ignore
    //   const sectionConfig = this.sectionConfig;
    //   if (!sectionConfig) return undefined;
    //   return sectionConfig && sectionConfig[key] && sectionConfig[key].tolerant_singleline_order ? sectionConfig[key].tolerant_singleline_order : this.getOrder(key);
    // },
    isRequired(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].priority=="mandatory" : false
    },
    isRecommended(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].priority=="recommended" : false
    },
    isOptional(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].priority=="optional" : false
    },
    isIfNotNull(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].priority=="ifNotNull" : false
    },
    isHidden(key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const sectionConfig = this.sectionConfig;
      if (!sectionConfig) return undefined;
      return sectionConfig && sectionConfig[key] ? sectionConfig[key].priority=="hidden" : false
    },
 
    touchForm(fieldName) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (!this.v$.form) return;
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.v$.form[fieldName].$touch();
    },
    getSelectLabelByValue(configKey, value) {
      const option = this.getSelectOptions(configKey).find(
        (o) => o.value === value
      );
      if (!option) return "";
      if (option.label !== null && option.label !== undefined)
        return option.label;
      if (option.translationKey) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return this.$t(option.translationKey);
      }
      return null;
    },
    getSelectOptions(configKey) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      return this.$c(configKey).map((s) => {
        return {
          translationKey: s.translationKey,
          value: s.key,
        };
      });
    },
  },
};
